import { AfterViewInit, Component, Inject, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
declare const google: any;

@Component({
  selector: 'act-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.scss']
})
export class GoogleMapComponent implements OnInit, OnChanges, AfterViewInit {
  private lat: Number;
  private lng: Number;

  @Input('latitude') latitude: Number;
  @Input('longitude') longitude: Number;
  @Input('class') class: string = 'map';

  private _zoom = 18;
  @Input() set zoom(zoom: number) {
    this._zoom = zoom || this._zoom;
  };

  constructor( @Inject(DOCUMENT) private document: Document, ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (changes['latitude'] || changes['longitude']) {
      this.lat = this.latitude;
      this.lng = this.longitude;
    }
  }

  ngAfterViewInit() {
    if (this.lat && this.lng) {
      this.buildMap(this.lat, this.lng, this._zoom);
    }
  }

  buildMap(latitude: Number, longitude: Number, zoom: Number) {
    if (latitude && longitude && latitude >= -90 && latitude <= 90 && longitude >= -180 && longitude <= 180) {
      const map = new google.maps.Map(this.document.getElementById('map'), {
        center: { lat: latitude, lng: longitude },
        scrollwheel: true,
        gestureHandling: 'greedy',
        zoom: zoom
      });
      const marker = new google.maps.Marker({
        map: map,
        position: { lat: latitude, lng: longitude },
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/google-map/google-map.component.ts